import JSX from "../../helpers/react.js";
import {ISelectValue, Select} from "../elements/Select.js";

export function TrailerPlayerSelect({players, index, onSelect}: {players: string[], index: number, onSelect: (index: string)=>any}){
    return (
        <div data-dub={index}>
            <Select multiple={false} placeholder="Выбор плеера" name="player_select_trailer" onChange={index=>onSelect(index!.value! as string)} initSelect={false}>
                {
                    ...players.map(
                        (player, index) => ({
                            value: player,
                            name: player.startsWith("Плеер")?player:'Плеер '+player,
                            selected: index == 0
                        } as ISelectValue)
                    )
                }
            </Select>
        </div>
    );

}